import { all, fork } from 'redux-saga/effects';

import { sagas as activitySaga } from './modules/BusinessModelsMarketing/activity';
import { sagas as behaviorSaga } from './modules/GrowthPlan/behavior';
import { sagas as BeneficiarySaga } from './modules/ImpactPlan/beneficiary';
import { sagas as beneficiaryTypesSaga } from './modules/ImpactPlan/beneficiaryTypes';
import { sagas as businessModelSaga } from './modules/BusinessModelsMarketing/businessModel';
import { sagas as chainSaga } from './modules/StakeholderMap/chain';
import { sagas as channelSaga } from './modules/StakeholderMap/channel';
import { sagas as commentSaga } from './modules/comment';
import { sagas as competitorSaga } from './modules/CompetitionMap/competitor';
import { sagas as distributionChannelCombinerSaga } from './modules/StakeholderMap/combiners/DistributionChannels';
import { sagas as emailDashboardMemberSaga } from './modules/EmailDashboardMember';
import { sagas as emailDashboardMentorSaga } from './modules/EmailDashboardMentor';
import { sagas as expenseSaga } from './modules/FinancialProjections/expense';
import { sagas as financialProductSaga } from './modules/FinancialProjections/financialProduct';
import { sagas as financialProjectionSaga } from './modules/FinancialProjections/financialProjection';
import { sagas as fixedAssetsSaga } from './modules/FinancialProjections/fixedAsset';
import { sagas as fundingsSaga } from './modules/FinancialProjections/funding';
import { sagas as growthRiskSaga } from './modules/GrowthPlan/growthRisk';
import { sagas as initiativeSaga } from './modules/GrowthPlan/initiative';
import { sagas as interestshipSaga } from './modules/Matching/interestship';
import { sagas as investmentsSaga } from './modules/FinancialProjections/investment';
import { sagas as IPresourceSaga } from './modules/ImpactPlan/resource';
import { sagas as keyResultSaga } from './modules/GrowthPlan/keyResult';
import { sagas as memberApplicationSaga } from './modules/memberApplication';
import { sagas as memberSaga } from './modules/member';
import { sagas as surveysResponsesSaga } from './modules/surveyResponse';
import { sagas as mentorApplicationSaga } from './modules/mentorApplication';
import { sagas as mentorMatchingCombinerSaga } from './combiners/mentorMatching';
import { sagas as mentorSaga } from './modules/mentor';
import { sagas as metricSaga } from './modules/GrowthPlan/metric';
import { sagas as milestoneSaga } from './modules/GrowthPlan/milestone';
import { sagas as monthlyCogsSaga } from './modules/FinancialProjections/monthlyCogs';
import { sagas as monthlyExpenseSaga } from './modules/FinancialProjections/monthlyExpense';
import { sagas as monthlyPayrollSaga } from './modules/FinancialProjections/monthlyPayroll';
import { sagas as monthlyPriceSaga } from './modules/FinancialProjections/monthlyPrice';
import { sagas as monthlyUnitsSoldSaga } from './modules/FinancialProjections/monthlyUnitsSold';
import { sagas as moonshotGoalSaga } from './modules/GrowthPlan/moonshotGoal';
import { sagas as notificationsSaga } from './modules/notifications';
import { sagas as objectiveSaga } from './modules/GrowthPlan/objective';
import { sagas as organizationalRoleSaga } from './modules/GrowthPlan/organizationalRole';
import { sagas as payrollSaga } from './modules/FinancialProjections/payroll';
import { sagas as pillsSaga } from './modules/Pills';
import { sagas as pillsCategoriesSaga } from './modules/PillsCategories';
import { sagas as pillsToolkitSaga } from './modules/PillsToolkit';
import { sagas as pricingModelSaga } from './modules/PricingBusinessViability/pricingModel';
import { sagas as productSaga } from './modules/product';
import { sagas as profilePictureSaga } from './modules/profilePicture';
import { sagas as programCombinerSaga } from './combiners/myProgram';
import { sagas as programMentorsSaga } from './modules/programMentors';
import { sagas as programSaga } from './modules/program';
import { sagas as programSetupSaga } from './modules/programSetup';
import { sagas as programToolsSaga } from './modules/programTools';
import { sagas as programStatsSaga } from './modules/programStats';
import { sagas as programToolsStep } from './modules/programStep';
import { sagas as projectSaga } from './modules/project';
import { sagas as projectSdgSaga } from './modules/ImpactPlan/projectSdg';
import { sagas as RelationshipSaga } from './modules/ImpactPlan/relationship';
import { sagas as resourceSaga } from './modules/StakeholderMap/resources';
import { sagas as resultSaga } from './modules/ImpactPlan/result';
import { sagas as retentionActivitySaga } from './modules/PricingBusinessViability/retentionActivity';
import { sagas as riskCategorySaga } from './modules/GrowthPlan/riskCategory';
import { sagas as roleSaga } from './modules/ImpactPlan/role';
import { sagas as ruleSaga } from './modules/ImpactPlan/rule';
import { sagas as scenarioSaga } from './modules/scenario';
import { sagas as sdgOutcomeIndicatorSaga } from './modules/ImpactPlan/outcomeIndicator';
import { sagas as sdgOutcomeSaga } from './modules/ImpactPlan/outcome';
import { sagas as sdgSaga } from './modules/ImpactPlan/sdg';
import { sagas as sdgTargetSaga } from './modules/ImpactPlan/sdgTarget';
import { sagas as segmentsSaga } from './modules/ValueProposition/segment';
import { sagas as statusSummarySaga } from './modules/statusSummary';
import { sagas as stepSaga } from './modules/Tools/step';
import { sagas as surveysSaga } from './modules/surveys';
import { sagas as systemSaga } from './modules/ImpactPlan/system';
import { sagas as toolSaga } from './modules/Tools/tool';
import { sagas as userSaga } from './modules/user';
import { sagas as valueSaga } from './modules/GrowthPlan/value';

import { sagas as managementPanelMemberSaga } from './modules/ManagementPanelMember';
import { sagas as managementPanelMentorSaga } from './modules/ManagementPanelMentor';
import { sagas as glossarySagas } from './modules/glossary';

// Tool PDF Sagas
import { sagas as stakeholderMapPdfSaga } from './modules/toolsPdf/StakeholderMap';
import { sagas as competitionMapPdfSaga } from './modules/toolsPdf/CompetitionMap';
import { sagas as businessModelsMarketingPdfSaga } from './modules/toolsPdf/BusinessModelsMarketing';
import { sagas as pricingBusinessViabilityPdfSaga } from './modules/toolsPdf/PricingBusinessViability';
import { sagas as financialProjectionsPdfSaga } from './modules/toolsPdf/FinancialProjections';
import { sagas as impactPlanPdfSaga } from './modules/toolsPdf/ImpactPlan';
import { sagas as growthPlanPdfSaga } from './modules/toolsPdf/GrowthPlan';

export default function* rootSaga() {
  yield all([
    fork(activitySaga),
    fork(behaviorSaga),
    fork(BeneficiarySaga),
    fork(beneficiaryTypesSaga),
    fork(businessModelSaga),
    fork(chainSaga),
    fork(channelSaga),
    fork(commentSaga),
    fork(competitorSaga),
    fork(distributionChannelCombinerSaga),
    fork(emailDashboardMemberSaga),
    fork(emailDashboardMentorSaga),
    fork(expenseSaga),
    fork(financialProductSaga),
    fork(financialProjectionSaga),
    fork(fixedAssetsSaga),
    fork(fundingsSaga),
    fork(growthRiskSaga),
    fork(initiativeSaga),
    fork(interestshipSaga),
    fork(investmentsSaga),
    fork(IPresourceSaga),
    fork(keyResultSaga),
    fork(memberApplicationSaga),
    fork(memberSaga),
    fork(surveysResponsesSaga),
    fork(mentorApplicationSaga),
    fork(mentorMatchingCombinerSaga),
    fork(mentorSaga),
    fork(metricSaga),
    fork(milestoneSaga),
    fork(monthlyCogsSaga),
    fork(monthlyExpenseSaga),
    fork(monthlyPayrollSaga),
    fork(monthlyPriceSaga),
    fork(monthlyUnitsSoldSaga),
    fork(moonshotGoalSaga),
    fork(notificationsSaga),
    fork(objectiveSaga),
    fork(organizationalRoleSaga),
    fork(payrollSaga),
    fork(pillsSaga),
    fork(pillsCategoriesSaga),
    fork(pillsToolkitSaga),
    fork(pricingModelSaga),
    fork(productSaga),
    fork(profilePictureSaga),
    fork(programCombinerSaga),
    fork(programMentorsSaga),
    fork(programSaga),
    fork(programSetupSaga),
    fork(programStatsSaga),
    fork(programToolsSaga),
    fork(programToolsStep),
    fork(projectSaga),
    fork(projectSdgSaga),
    fork(RelationshipSaga),
    fork(resourceSaga),
    fork(resultSaga),
    fork(retentionActivitySaga),
    fork(riskCategorySaga),
    fork(roleSaga),
    fork(ruleSaga),
    fork(scenarioSaga),
    fork(sdgOutcomeIndicatorSaga),
    fork(sdgOutcomeSaga),
    fork(sdgSaga),
    fork(sdgTargetSaga),
    fork(segmentsSaga),
    fork(statusSummarySaga),
    fork(stepSaga),
    fork(surveysSaga),
    fork(systemSaga),
    fork(toolSaga),
    fork(userSaga),
    fork(valueSaga),

    fork(managementPanelMemberSaga),
    fork(managementPanelMentorSaga),
    fork(glossarySagas),
    // Tool PDF Sagas
    fork(stakeholderMapPdfSaga),
    fork(competitionMapPdfSaga),
    fork(businessModelsMarketingPdfSaga),
    fork(pricingBusinessViabilityPdfSaga),
    fork(financialProjectionsPdfSaga),
    fork(impactPlanPdfSaga),
    fork(growthPlanPdfSaga),
  ]);
}
